export const createDownloadBlobByFileName = (fileName: string) => (blob: string) => {
  const a = document.createElement('a')
  a.download = fileName
  a.target = '_blank'
  a.href = window.URL.createObjectURL(new Blob([blob], { type: 'text/plain' }))
  a.click()
}
